<template>
  <div
    class="brick-item"
    v-if="signboard.status=='show'"
    :style="{ width: width, flexGrow: flexGrow }"
  >
    <i :style="{ paddingBottom: paddingBottom}"></i>
    <router-link :to="{name:'menu', params:{slug:signboard.slug}}">
      <img v-lazy="signboard.icon" alt class="brick-item-image" />
      <div class="img_lable d-flex">
        <div class="flex-grow-1">
          <div class="title">{{signboard.name}}</div>
          <div class="des">{{signboard.description}}</div>
        </div>
        <div class="btn btn-secondary align-self-center btn-sm">
          快速點餐
          <b-icon-hand-index variant="light"></b-icon-hand-index>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    signboard: {
      status: "",
      slug: "",
      icon: "",
      name: "",
      description: ""
    }
  },

  data: () => ({
    width: "",
    height: 200,
    imageWidth: 300,
    imageHeight: 400,
    flexGrow: 0,
    paddingBottom: 0
  }),
  created() {
    this.setDivWidth(this.signboard.icon);
    this.setDivFlexGrow(this.signboard.icon);
    this.setIPaddingBottom(this.signboard.icon);
  },
  updated() {
    this.setDivWidth(this.signboard.icon);
    this.setDivFlexGrow(this.signboard.icon);
    this.setIPaddingBottom(this.signboard.icon);
  },

  methods: {
    async setDivWidth(image_url) {
      const res = await this.loadImage(image_url);
      this.width = (res.width * this.height) / res.height + "px";
    },
    async setDivFlexGrow(image_url) {
      const res = await this.loadImage(image_url);
      this.flexGrow = (res.width * this.height) / res.height;
    },
    async setIPaddingBottom(image_url) {
      const res = await this.loadImage(image_url);
      this.paddingBottom = (res.height / res.width) * 100;
    },
    loadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = e => reject(e);
        img.src = src;
      });
    }
  }
};
</script>